import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
// import App from './App'; / <App />
import Router from "./container/router";
import reportWebVitals from "./reportWebVitals";
// import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/line-awesome.min.css";
import "./assets/css/fontawesome.min.css";
// import "./assets/css/style.css";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Provider } from "react-redux";
import { store } from "./store/store";
import * as Sentry from "@sentry/react";
import { SENTRY_DNS_URL,URL_BASE_API} from "./utilities/urlConfigs";
import { getStorage } from "./utilities/browserStorage";
import ThemeCustomization from "./themes";

const userGroupData = JSON.parse(getStorage("userData") || "{}");

if (SENTRY_DNS_URL) {
  Sentry.init({
    dsn: SENTRY_DNS_URL,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration()
    ],
    // Tracing - 70% of transactions
    tracesSampleRate: 0.70,
    // Profiling - 100% of traced transactions (70% of total transactions)
    profilesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  if(userGroupData.username){
    Sentry.setUser({ email: userGroupData.username })
    Sentry.setTag('client',URL_BASE_API)
  }
}

ReactDOM.render(
  <ThemeCustomization>
    <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
        <React.Fragment>
          <Router />
        </React.Fragment>
        </LocalizationProvider>
    </Provider>
  </ThemeCustomization>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();